module.exports = __webpack_public_path__ + "img/t2-1.2bccfeaa.svg";